import { render, staticRenderFns } from "./Repo.vue?vue&type=template&id=615450c8&scoped=true&"
import script from "./Repo.vue?vue&type=script&lang=js&"
export * from "./Repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615450c8",
  null
  
)

export default component.exports